import styled from "styled-components";
import { maxWidth, size, bottom, display } from "styled-system";
import { Box, Text } from "rebass";
import { useState } from "react";
import YouTube from "react-youtube";
import SVG from "react-inlinesvg";
import { theme } from "../styles/theme";
import { Arrow } from "./arrow";

const Video = ({ poster, alt, youtube_id, onButtonClick }) => {
  const [open, setOpen] = useState(false);
  const [playerReady, setPlayerReady] = useState(false);
  const opts = { playerVars: { autoplay: 1 } };

  const _onReady = () => {
    setPlayerReady(true);
  };

  const _close = () => {
    setOpen(false);
    setPlayerReady(false);
  };

  const _onPosterClick = () => {
    setOpen(true);
  };

  return (
    <Wrapper>
      <ResponsiveWrap
        as="a"
        onClick={_onPosterClick}
        href="javascript:void(0);"
        role="button"
      >
        <img src={poster} alt={alt} />
        <PlayWrap>
          <PlayButton size={[86]} src="/static/images/play-btn.svg" />
          <Text textAlign="center" fontFamily="medium" fontSize={1} mt={3}>
            Play
          </Text>
        </PlayWrap>
      </ResponsiveWrap>
      <StyledArrow
        display={["none", "none", "block"]}
        size={50}
        bottom={theme.space[6]}
        onClick={onButtonClick}
      />
      {open && (
        <>
          <VideoWrap
            p={[3, 3, 3, 4]}
            maxWidth={["80%", "80%", "80%", "60%"]}
            width={1}
          >
            {playerReady && (
              <Text
                mb={[2, 2, 2, 3]}
                textAlign="center"
                fontFamily="medium"
                fontSize={1}
              >
                <a onClick={_close} href="javascript:void(0);" role="button">
                  Close
                </a>
              </Text>
            )}
            <ResponsiveWrap>
              <YouTube videoId={youtube_id} opts={opts} onReady={_onReady} />
            </ResponsiveWrap>
          </VideoWrap>
          <Skrim onClick={_close} />
        </>
      )}
    </Wrapper>
  );
};

const StyledArrow = styled(Arrow)`
  ${size}
  ${bottom}
  ${display}
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

const PlayButton = styled(SVG)`
  ${size}
  display: block;
  transition: transform 0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946);

  svg {
    fill: currentColor;
    width: 100%;
    height: 100%;
    display: block;
  }
`;

const PlayWrap = styled(Box)`
  position: absolute;
  z-index: 1;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  transition: opacity 0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946);
`;

const Wrapper = styled(Box)`
  position: relative;
`;

const Skrim = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.5;
  width: 100%;
  height: 100%;
`;

const VideoWrap = styled(Box)`
  ${maxWidth}
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  z-index: 1;
`;

const ResponsiveWrap = styled(Box)`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
  display: block;

  &:hover ${PlayWrap}, &:focus ${PlayWrap} {
    opacity: 0.7;

    ${PlayButton} {
      transform: scale(1.1, 1.1);
    }
  }

  img,
  iframe {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: cover;
  }
`;

export { Video };
